import React from "react";
import Title from "../../components/TitleComponent";
import { Row, Col } from "react-bootstrap";
import { Image } from "react-bootstrap";
import Details from "../../components/DetailsComponent";
import { Helmet } from "react-helmet-async";

export default function RecoverTherapy() {

  return (
    <>
    <Helmet>
        <title>Terapia de recuperare in autism - intrebari si clarificari</title>
        <meta
          name="description"
          content="Desi comunitatea stiintifica nu a identificat inca clar cauza/ cauzele care determina aparitia acestei tulburari de dezvoltare, cu siguranta diagnosticarea si interventia timpurie sunt absolut necesare pentru a creste sansele de evolutie si de dezvoltare a unor abilitati de viata independenta. Asociatia PsiNapsis Sibiu"
        />
        <link rel="canonical" href="https://www.psinapsis.ro/articles/recovertherapyarticle" />
      </Helmet>

      <Row className="p-0 m-0">
        <Col className="d-none d-xl-block"></Col>
        <Col className="whiteBg p-0 m-0 pb-5 min-xl-screen-size">
          <Title
            title="Terapia de recuperare in autism. Intrebari si clarificari"
          />

          <Details 
          normalText="Estimarile existente in acest moment sustin ca 1 din 36 de copii este diagnosticat cu tulburare de spectru autist (ADDM). In viitor, unul din 36 de adulti va prezenta, intr-o formă sau alta, particularitatile specifice acestei tulburari si va fi nevoit sa infrunte impactul acestora asupra posibilitatilor sale de integrare. Prin urmare, fara intelegerea diferentelor si acceptarea lor, fara oferirea de sanse in directia integrarii sociale, scolare si profesionale, nu doar persoanele diagnosticate cu TSA au de suferit, ci si societatea in ansamblul ei." />

          <Details 
          normalText="Desi comunitatea stiintifica nu a identificat inca clar cauza/ cauzele care determina aparitia acestei tulburari de dezvoltare, cu siguranta diagnosticarea si interventia timpurie sunt absolut necesare pentru a creste sansele de evolutie si de dezvoltare a unor abilitati de viata independenta." />

          <Details normalText="In tot acest proces de recuperare, relatia de colaborare dintre specialisti si familie este esentiala." />

          <Details
          normalText="Primim intrebari si ne sunt impartasite diverse nelamuriri cu privire la alegerea: tipului de terapie, clasica si/sau complementara, daca aceasta sa fie individuala sau de grup, daca sa asiste parintele in timpul terapiei sau nu, frecventa saptamanala a sedințelor de terapie, costul terapiei de recuperare, posibilitatea decontarii acestui cost, evaluarea progresului copilului in terapie, obtinerea incadrarii intr-un grad de handicap si.... multe altele."/>

          <Details 
          normalText="Valorificam experienta de mai bine de 10 ani in sfera evaluarii si interventiei in TSA (sute de copii evaluati, sute de familii intalnite) si raspundem intrebarilor care ne sunt adresate constant."/>

          <div className="text-center">
            <Image
              src="/images/art_autism.jpg"
              alt="Terapia de recuperare in autism, Nicoleta Ilies, Stroe Ioana, Asociatia PsiNapsis Sibiu"
              className="align-center photoArtAutism"
            />
          </div>

        </Col>
        <Col className="d-none d-xl-block"></Col>
      </Row>
    </>
  );
}
